import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = {
    key: "actions",
    class: "float-end"
};
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = { class: "form-contents" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = {
    key: "profile-panel",
    class: "col-xs-12 col-sm-12"
};
const _hoisted_10 = {
    key: "profile",
    class: "clearfix"
};
const _hoisted_11 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_12 = { class: "col-xs-12 col-sm-12" };
const _hoisted_13 = { class: "float-end" };
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_16 = { class: "invalid-feedback" };
const _hoisted_17 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_19 = { class: "invalid-feedback" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_23 = { class: "d-flex bottom10" };
const _hoisted_24 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isApplicationArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing user name...'), 3 /* TEXT, CLASS */)
            ]),
            _cache[18] || (_cache[18] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save
                        }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "danger",
                            onClick: _ctx.archive
                        }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication && !_ctx.isApplicationArchived]
                        ]),
                        _cache[15] || (_cache[15] = _createTextVNode()),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "warning",
                            onClick: _ctx.restore
                        }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication && _ctx.isApplicationArchived]
                        ]),
                        _cache[16] || (_cache[16] = _createTextVNode()),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "warning",
                            onClick: _ctx.changeSecret
                        }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Change Secret", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication]
                        ]),
                        _cache[17] || (_cache[17] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _cache[53] || (_cache[53] = _createTextVNode()),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"]),
                _cache[40] || (_cache[40] = _createTextVNode()),
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-xs-12 col-sm-12" }, null, -1 /* CACHED */)),
                _cache[42] || (_cache[42] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                _createElementVNode("div", _hoisted_10, [
                                    (_ctx.appHasLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _createElementVNode("div", _hoisted_13, [
                                                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "Last Active", -1 /* CACHED */)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.whenLastActiveString), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[39] || (_cache[39] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _cache[20] || (_cache[20] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[21] || (_cache[21] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                modelValue: _ctx.application.applicationName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.application.applicationName) = $event)),
                                                modelModifiers: { trim: true },
                                                name: "applicationName",
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name },
                                                maxlength: "100"
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_16, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter an application name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _cache[35] || (_cache[35] = _createTextVNode()),
                                        (!_ctx.isNewApplication && _ctx.application.applicationSecret && !_ctx.newSecret)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _cache[23] || (_cache[23] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tAPI secret initials\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.application.applicationSecret,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.application.applicationSecret) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "applicationSecret",
                                                    maxlength: "100",
                                                    disabled: ""
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[36] || (_cache[36] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_18, [
                                            _cache[25] || (_cache[25] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tToken Lifetime (minutes) *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[26] || (_cache[26] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.tokenVal, {
                                                type: "number",
                                                modelValue: _ctx.application.tokenLifetime,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.application.tokenLifetime) = $event)),
                                                modelModifiers: { trim: true },
                                                name: "applicationSecret",
                                                class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.token },
                                                min: "60",
                                                step: "30"
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[27] || (_cache[27] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_19, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a token lifetime (minutes)\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.token]
                                            ])
                                        ]),
                                        _cache[37] || (_cache[37] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_20, [
                                            _cache[30] || (_cache[30] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tMapped Principal\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[31] || (_cache[31] = _createTextVNode()),
                                            _createVNode(_component_b_alert, {
                                                variant: "primary",
                                                dismissible: "",
                                                modelValue: _ctx.showInfoMessage,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.showInfoMessage) = $event))
                                            }, {
                                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tYou can map an application account to a user principal, granting the application the same permissions as the user.\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */),
                                                        _createElementVNode("br", null, null, -1 /* CACHED */),
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tThis is recommended for integrations that manufacture data linked to companies and systems.\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"]),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _createVNode(_component_multiselect, {
                                                name: "userPrincipal",
                                                modelValue: _ctx.userPrincipal,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.userPrincipal) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: _ctx.selectPlaceholder,
                                                options: _ctx.users,
                                                showLabels: false
                                            }, {
                                                noResult: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                        ]),
                                        _cache[38] || (_cache[38] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_21, [
                                            _cache[33] || (_cache[33] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[34] || (_cache[34] = _createTextVNode()),
                                            _createVNode(_component_b_form_textarea, {
                                                name: "description",
                                                modelValue: _ctx.application.applicationDescription,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.application.applicationDescription) = $event)),
                                                rows: "5"
                                            }, null, 8 /* PROPS */, ["modelValue"])
                                        ])
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ]),
        _cache[54] || (_cache[54] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            id: "newToken",
            modelValue: _ctx.showNewAPISecret,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.showNewAPISecret) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode("\r\n\t\t\t\tNew API Secret\r\n\t\t\t", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.showNewAPISecret = false))
                    }, {
                        default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            default: _withCtx(() => [
                _cache[51] || (_cache[51] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tThis is your new API secret token\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[47] || (_cache[47] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.newSecret,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.newSecret) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "applicationSecret",
                                    maxlength: "100",
                                    readonly: ""
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _cache[45] || (_cache[45] = _createTextVNode()),
                                _createVNode(_component_b_button, {
                                    class: "m-0 ms-2",
                                    type: "button",
                                    variant: "primary",
                                    onClick: _ctx.copyToClipboard,
                                    title: "Copy to clipboard"
                                }, {
                                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                            _createElementVNode("i", {
                                                class: "fa fa-clipboard",
                                                "aria-hidden": "true"
                                            }, null, -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ]),
                            _cache[48] || (_cache[48] = _createTextVNode()),
                            _cache[49] || (_cache[49] = _createElementVNode("span", null, "Copy the token; once this form has been closed, it cannot be retrieved again.", -1 /* CACHED */))
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[52] || (_cache[52] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
